'use strict'

module.exports = (function () {
    /**
    * @ngdoc method
    * @name alertBanner
    * @description Initializes alert banner behavior
    * If a close button is specified, the alert bar should be closed when that button is clicked.
    * Otherwise, close the alert bar when it is clicked anywhere
    **/

    var initialize = function (alertBarSelector, closeBtnSelector) {
        var $alertCloseBtn = $(closeBtnSelector);
        var $alertEl = $(alertBarSelector);
        if ($alertEl.length === 0) {
            return;
        }

        var onCloseClick = () => {
            var $this = $(this);
            $alertEl.slideUp(function () {
                $this.remove();
            });

            var hash = window.primaryNavAlertHash || "1";
            document.cookie = "closedAlertBar=" + hash + '; path=/';
        };

        if ($alertCloseBtn.length > 0) {
            $alertCloseBtn.on('click', onCloseClick);
        }
        else {
            $alertEl.on('click', onCloseClick);
        }
    }

    return {
        initialize: initialize
    };
}())